// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"GlobalUsersTable_ProseMirror__3ihae","table_empty":"GlobalUsersTable_table_empty__fZWCf"};